import { Title } from "@unit-finance/unit-node-sdk";

import {
    AnnualIncome,
    AnnualRevenue,
    BusinessVertical,
    CashFlow,
    NumberOfEmployees,
    Occupation,
    SourceOfIncome,
} from "../../types/unit";

export enum UsOperations {
    Yes = "yes",
    No = "no",
}

export interface IBusinessInformationFormData {
    entityType: string;
    name: string;
    stateOfIncorporation: string;
    dba: string | null;
    ein: string | null;
    noEin: boolean;
    businessVertical: BusinessVertical;
    yearOfIncorporation: Date;
    annualRevenue: AnnualRevenue;
    numberOfEmployees: NumberOfEmployees;
    usOperations: UsOperations;
    countriesOfOperation: string[];
    cashFlow: CashFlow;
    phoneNumberFull: string;
    phoneCountryCode: string;
    phoneNumber: string;
    website: string;
    addressStreet: string;
    addressStreet2: string;
    addressCity: string;
    addressDistrict: string;
    addressZipcode: string;
    addressCountry: string;
}

export interface IOfficerInformationFormData {
    firstName: string;
    lastName: string;
    title: Title;
    phoneNumberFull: string;
    phoneCountryCode: string;
    phoneNumber: string;
    email: string;
    ssn: string | null;
    usePassport: boolean;
    passportNumber: string | null;
    nationality: string | null;
    dob: Date;
    addressStreet: string;
    addressStreet2: string;
    addressCity: string;
    addressDistrict: string;
    addressZipcode: string;
    addressCountry: string;
    isOfficer: boolean;
    bcFirstName: string;
    bcLastName: string;
    bcEmail: string;
    bcPhoneNumberFull: string;
    bcPhoneCountryCode: string;
    bcPhoneNumber: string;
}

export interface BeneficialOwner {
    firstName: string;
    lastName: string;
    dob: Date | undefined;
    ssn: string | null;
    usePassport: boolean;
    passportNumber: string | null;
    nationality: string | null;
    email: string;
    percentage: number | undefined;
    phoneNumberFull: string;
    phoneCountryCode: string;
    phoneNumber: string;
    addressStreet: string;
    addressStreet2: string;
    addressCity: string;
    addressDistrict: string;
    addressZipcode: string;
    addressCountry: string;
    isOfficer?: boolean;
}

export interface IBeneficialOwnersFormData {
    beneficialOwner: BeneficialOwner[];
    agreeToTerms1: boolean;
    agreeToTerms2: boolean;
}

export interface IAdditionalPersonData {
    occupation: Occupation;
    annualIncome: AnnualIncome;
    sourceOfIncome: SourceOfIncome;
}

export interface IAdditionalInformationFormData {
    officer: IAdditionalPersonData;
    beneficialOwners: IAdditionalPersonData[];
}
